module.exports = __webpack_public_path__ + "img/The Protein Box.3fbd80ca.svg";